// extracted by mini-css-extract-plugin
export var inlineLink = "_47-0";
export var inlineLinkButton = "_47-1";